import {Component, Inject} from 'ng-metadata/core';
import {JwtUtilService} from "../../../../security/jwtUtil.service";
import {beacon, PrimolyticsService} from '../../../../analytics/primolytics.service';
import {LoginService} from '../../../../security/login/login.service';
import { NgrsService } from '../ngrs.service';


@Component({
    "selector": "prm-rapido-no-offer-message",
    templateUrl: 'components/search/fullView/ngrs/rapidoNoOfferMessage/rapidoNoOfferMessage.html'
})

export class PrmRapidoNoOfferMessage{

    private _showForm = false;
    private _messageContent;
    private messageLinkable: boolean = false;
    
    constructor (private jwtUtilService: JwtUtilService,
        private loginService: LoginService,
        private ngrsService: NgrsService,
        private primolyticsService: PrimolyticsService,
        @Inject('$sce') private $sce,		
        @Inject('$translate') private $translate: ng.translate.ITranslateService){       
    }

    ngOnInit(){
        this._showForm = false;
        this.ngrsService.getRapidoNoOfferMessage().then(value=> {
            if(value){
                this._messageContent = this.$sce.trustAsHtml(value);
                this.messageLinkable = true;
            }else{
                this.messageLinkable = false;
            }
        });
    }

    public isSignedIn(){
        return this.jwtUtilService.isSignedIn();
    } 

    @beacon({'p':'general', 'op':'signIn'})
    public signIn(){
        this.loginService.handleLoginClick();
    }

    public getShowForm(){
        return this._showForm;
    }

    public clickOnNoOfferMessage(){
        this._showForm = true;
    }

    public getMessage(){
        if(this._messageContent){
            return this._messageContent;
        }
        return "";
    }

    public clickBack(){
        this._showForm = false;
    }

    public getExpandAriaLabel(){
        return this.$translate.instant('nui.ngrs.no.offer.message.termsAndConditions.first') + ' ' + 
            this.$translate.instant('nui.ngrs.no.offer.message.termsAndConditions.second');
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/rapidoNoOfferMessage/rapidoNoOfferMessage.directive.ts